module.exports = __webpack_public_path__ + "img/sko.e3c9047c.jpg";